import { render, staticRenderFns } from "./PlanAlokasiMuatUpload.vue?vue&type=template&id=6f45773c&scoped=true&"
import script from "./PlanAlokasiMuatUpload.vue?vue&type=script&lang=js&"
export * from "./PlanAlokasiMuatUpload.vue?vue&type=script&lang=js&"
import style1 from "./PlanAlokasiMuatUpload.vue?vue&type=style&index=1&id=6f45773c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45773c",
  null
  
)

export default component.exports